import Constants, { EBB_TERMS, NNYB_TERMS, BRU_TERMS } from "app/shared/constants/constants";

//BASE CDN URL
const baseURL = process.env.REACT_APP_CDN_BASE_URL || "https://dastore-eea4hdcsdnb9h8cj.z01.azurefd.net";

//Noah's Logo
const nnybBanner = `${baseURL}/da-store-nnyb/images/banners/banner.jpg`;
const nnybPerksLogo = `${baseURL}/da-store-nnyb/images/logos/perks_logo.png`;
const nnybLogo = `${baseURL}/da-store-nnyb/images/logos/brand-logo.png`;
const nnybGiftCardIcon = `${baseURL}/da-store-nnyb/images/logos/giftcard_logo.svg`;

//Einstein's Logos
const ebbBanner = `${baseURL}/da-store-ebb/images/banners/banner.jpg`;
const ebbPerksLogo = `${baseURL}/da-store-ebb/images/logos/perks_logo.png`;
const ebbLogo = `${baseURL}/da-store-ebb/images/logos/brand-logo.png`;
const ebbGiftCardIcon = `${baseURL}/da-store-ebb/images/logos/giftcard_logo.svg`;

//Bruegger's Logo
const bruBanner = `${baseURL}/da-store-bru/images/banners/banner.jpg`;
const bruPerksLogo = `${baseURL}/da-store-bru/images/logos/perks_logo.png`;
const bruLogo = `${baseURL}/da-store-bru/images/logos/brand-logo.png`;
const bruWelcomeBackLogo = `${baseURL}/da-store-bru/images/logos/bru_welcomeBack_logo.png`;
const bruGiftCardIcon = `${baseURL}/da-store-bru/images/logos/giftcard_logo.svg`;

type BrandDetails = {
    brandTitle: string,
    brandContainer:string,
    brandLogoPath: string,
    letsGetStartedBanner: string,
    brandName: string,
    appSource: string,
    appPlatform: string,
    brandYextValue:string,
    rewardsLogoPath: string,
    nutritionURL: string,
    programPreference: string,
    allLogos?: { [key: string]: string },
    termsConditionURL: string,
    rewardsText: string,
    signUpHeaderText: string,
    resetPasswordBrand: string,
    unsubscribePreference: string,
    unsubscribeDescription: string,
    deepLink: string,
    termsAndConditions: string,
    giftCardIcon: string;
    cateringUrl: string;
};

const getBrandName = (): BrandDetails => {
    // eslint-disable-next-line max-len
    let host: string | undefined = window.location.hostname === 'localhost' ? process.env.REACT_APP_DEV_HOST_NAME : window.location.hostname; // TODO: need to check until prod
    if (window.location.hostname.includes(`-staging`)) {
        host = 'einsteinbros.com';
    }
    let brandObject: BrandDetails;
    brandObject = {
        brandTitle: '',
        brandContainer: '',
        brandLogoPath: '',
        letsGetStartedBanner: '',
        brandName: '',
        appSource: '',
        appPlatform: '',
        brandYextValue: '',
        rewardsLogoPath: '',
        nutritionURL: '',
        programPreference: '',
        termsConditionURL: '',
        rewardsText: '',
        signUpHeaderText: '',
        resetPasswordBrand: '',
        unsubscribePreference: '',
        unsubscribeDescription: '',
        deepLink: '',
        termsAndConditions: '',
        giftCardIcon: '',
        cateringUrl: '',
    };
    const allLogos = {
        ebbPerksLogo,
        bruPerksLogo,
        nnybPerksLogo,
        ebbLogo,
        bruLogo,
        nnybLogo,
        bruWelcomeBackLogo,
    };

    if (host) {
        if (host.endsWith(Constants.EINSTEIN_DOMAIN)) {
            brandObject = {
                brandTitle: Constants.EBB_TITLE,
                brandContainer: Constants.EBB_CDN_NAME,
                brandLogoPath: ebbLogo,
                letsGetStartedBanner: ebbBanner,
                brandName: Constants.EINSTEIN_APP,
                appSource: Constants.EBB_APP,
                appPlatform: Constants.EBB_ORDER_AHEAD_WEB,
                brandYextValue: Constants.EBB_YEXT_VALUE,
                rewardsLogoPath: ebbPerksLogo,
                nutritionURL: Constants.EBB_NUTRITION_URL,
                programPreference: Constants.EINSTEIN_PROGRAM_PREFERENCE,
                allLogos,
                termsConditionURL: Constants.EBB_APP_TERMS_CONDITION_URL,
                rewardsText: Constants.EBB_REWARDS,
                signUpHeaderText: Constants.EBB_SIGNUP_HEADER_TEXT,
                resetPasswordBrand: Constants.RESET_PASSWORD_BRAND_EBB,
                unsubscribePreference: Constants.EBB_UNSUBSCRIBE_PREFERENCE,
                unsubscribeDescription: Constants.EBB_UNSUBSCRIBE_DESCRIPTION,
                deepLink: Constants.EBB_DEEP_LINK,
                termsAndConditions: process.env.REACT_APP_EBB_TERMS || EBB_TERMS,
                giftCardIcon: ebbGiftCardIcon,
                cateringUrl: Constants.EBB_CATERING,
            };
            return brandObject;
        }
        if (host.endsWith(Constants.NOAH_DOMAIN)) {
            brandObject = {
                brandTitle: Constants.NNYB_TITLE,
                brandContainer: Constants.NNYB_CDN_NAME,
                brandLogoPath: nnybLogo,
                letsGetStartedBanner: nnybBanner,
                brandName: Constants.NOAH_APP,
                appSource: Constants.NNYB_APP,
                appPlatform: Constants.NNYB_ORDER_AHEAD_WEB,
                brandYextValue: Constants.NNYB_YEXT_VALUE,
                rewardsLogoPath: nnybPerksLogo,
                nutritionURL: Constants.NNYB_NUTRITION_URL,
                programPreference: Constants.NOAH_PROGRAM_PREFERENCE,
                allLogos,
                termsConditionURL: Constants.NNYB_APP_TERMS_CONDITION_URL,
                rewardsText: Constants.NOAH_REWARDS,
                signUpHeaderText: Constants.NNYB_SIGNUP_HEADER_TEXT,
                resetPasswordBrand: Constants.RESET_PASSWORD_BRAND_NNYB,
                unsubscribePreference: Constants.NNYB_UNSUBSCRIBE_PREFERENCE,
                unsubscribeDescription: Constants.NNYB_UNSUBSCRIBE_DESCRIPTION,
                deepLink: Constants.NOAH_DEEP_LINK,
                termsAndConditions: process.env.REACT_APP_NNYB_TERMS || NNYB_TERMS,
                giftCardIcon: nnybGiftCardIcon,
                cateringUrl: Constants.NOAHS_CATERING,
            };
            return brandObject;
        }
        if (host.endsWith(Constants.BRUEGGERS_DOMAIN)) {
            brandObject = {
                brandTitle: Constants.BRU_TITLE,
                brandContainer: Constants.BRU_CDN_NAME,
                brandLogoPath: bruLogo,
                letsGetStartedBanner: bruBanner,
                brandName: Constants.BRUEGGERS_APP,
                appSource: Constants.BRU_APP,
                appPlatform: Constants.BRU_ORDER_AHEAD_WEB,
                brandYextValue: Constants.BRU_YEXT_VALUE,
                rewardsLogoPath: bruPerksLogo,
                nutritionURL: Constants.BRU_NUTRITION_URL,
                programPreference: Constants.BRUEGGERS_PROGRAM_PREFERENCE,
                allLogos,
                termsConditionURL: Constants.BRU_APP_TERMS_CONDITION_URL,
                rewardsText: Constants.BRU_REWARDS,
                signUpHeaderText: Constants.BRU_SIGNUP_HEADER_TEXT,
                resetPasswordBrand: Constants.RESET_PASSWORD_BRAND_BRU,
                unsubscribePreference: Constants.BRU_UNSUBSCRIBE_PREFERENCE,
                unsubscribeDescription: Constants.BRU_UNSUBSCRIBE_DESCRIPTION,
                deepLink: Constants.BRU_DEEP_LINK,
                termsAndConditions: process.env.REACT_APP_BRU_TERMS || BRU_TERMS,
                giftCardIcon: bruGiftCardIcon,
                cateringUrl: Constants.BRUEGGERS_CATERING,
            };
            return brandObject;
            // } else if (host.includes("localhost")) {
            //     return Constants.BRUEGGERS_APP;
        }
        throw Error('Application Config Error');
    }
    return brandObject;
};

export default getBrandName;
